import { render, staticRenderFns } from "./CouponProductList.vue?vue&type=template&id=3538be39&scoped=true"
import script from "./CouponProductList.vue?vue&type=script&lang=js"
export * from "./CouponProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3538be39",
  null
  
)

export default component.exports